import { useSyncExternalStore } from "react";

const subscribeToNothing = () => () => {};

// React reads the server snapshot while hydrating (and when prerendering) and
// the client snapshot for every other render, so this is true exactly while
// the component is being hydrated from prerendered HTML. Right after
// hydration React re-renders with `false`, so values that only exist in the
// browser (localStorage caches, etc.) can be swapped in without a mismatch.
export const useIsHydrating = (): boolean =>
  useSyncExternalStore(
    subscribeToNothing,
    () => false,
    () => true
  );
